import { render, staticRenderFns } from "./noticeSetting.vue?vue&type=template&id=e1636e7c&scoped=true&"
import script from "./noticeSetting.vue?vue&type=script&lang=js&"
export * from "./noticeSetting.vue?vue&type=script&lang=js&"
import style0 from "./noticeSetting.vue?vue&type=style&index=0&id=e1636e7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1636e7c",
  null
  
)

export default component.exports